import { Pipe, PipeTransform } from '@angular/core';
import { FlatAssignmentResult, Column } from '../../../../shared/types/reports';
import { compare } from '../../../../shared/utils/sort';

/**
 * Sorts flat assignment results by bill column ascending or descending. If the column is not 'Bill', the results
 * are returned unsorted because another pipe handles the other columns. Sorting is done first by measure type
 * and then by measure num if the measure types are equal.
 * @see FlatAssignmentResult
 * @see AssignmentSortPipe
 */
@Pipe({
    name: 'billSort',
    standalone: false,
})
export class BillSortPipe implements PipeTransform {
    transform(
        results: FlatAssignmentResult[],
        column: Column,
        ascending: boolean,
    ): FlatAssignmentResult[] {
        if (column !== Column.Bill) return results;
        return results.sort((first, second) => {
            let [firstVal, secondVal] =
                first.measureType === second.measureType
                    ? [first.measureNum, second.measureNum]
                    : [first.measureType, second.measureType];
            return compare(firstVal, secondVal, ascending);
        });
    }
}
